import { BoxesApiRemoteService } from '../../Services/api/boxes/boxes-service'
import { IUpdateBoxPayload } from '../../Services/api/boxes/boxes.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class UpdateBoxesUseCase
implements IFormUsecase<IUpdateBoxPayload, void> {
  constructor (private readonly BoxesApi: BoxesApiRemoteService) {}
    

  public async handle (
    data: IUpdateBoxPayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.BoxesApi.update(data)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
